import { CalendarContext } from './calendar-context'
import { CalendarEvent, Mode } from './calendar-types'
import React, { useState } from 'react'
import CalendarNewEventDialog from './dialog/calendar-new-event-dialog'
import { usePermissions } from 'react-admin'
import TaxiOrderDetails from '@/taxi-dispatch/orders/OrderDetails'  
import OrderDetails from '@/tours-agent/orders/OrderDetails'

export default function CalendarProvider({
  events,
  setEvents,
  mode,
  setMode,
  date,
  setDate,
  endDate,
  setEndDate,
  calendarIconIsToday = true,
  children,
}: {
  events?: CalendarEvent[]
  setEvents?: (events: CalendarEvent[]) => void
  mode: Mode
  setMode: (mode: Mode) => void
  date: Date
  setDate: (date: Date) => void
  endDate?: Date,
  setEndDate?: (date: Date) => void,
  calendarIconIsToday: boolean
  children: React.ReactNode
}) {
  const permission = usePermissions()
  const [newEventDialogOpen, setNewEventDialogOpen] = useState(false)
  const [manageEventDialogOpen, setManageEventDialogOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null)

  return (
    <CalendarContext.Provider
      value={{
        events: events || [],
        setEvents: setEvents || function() {},
        mode,
        setMode,
        date,
        setDate,
        endDate,
        setEndDate,
        calendarIconIsToday,
        newEventDialogOpen,
        setNewEventDialogOpen,
        manageEventDialogOpen,
        setManageEventDialogOpen,
        selectedEvent,
        setSelectedEvent,
      }}
    >
      <CalendarNewEventDialog />
      {permission.data?.settings_type === 'taxi' && 
        <TaxiOrderDetails 
          isSheetOpen={manageEventDialogOpen}
          setIsSheetOpen={setManageEventDialogOpen}
          selectedOrder={selectedEvent} 
        />
      }
      {permission.data?.settings_type === 'transportation_agency' && 
        <OrderDetails isSheetOpen={manageEventDialogOpen} selectedOrder={selectedEvent as any} setIsSheetOpen={setManageEventDialogOpen} />
      }
      {children}
    </CalendarContext.Provider>
  )
}
